// extracted by mini-css-extract-plugin
export default {"button":"Ui_button__IlfTF","input":"Ui_input__GbpX1","text_area":"Ui_text_area__Y6Bku","card":"Ui_card__6vvt2"};